import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ExportFormat, ExportType} from '../../export/export-container/export-container.component';
import {SampService} from '../samp.service';
import {tap} from 'rxjs/operators';

export type SampSelectionType = 'all-rows' | 'selected-rows';

export interface SampExportEvent {
  readonly selectionType: SampSelectionType;
  readonly format: ExportFormat;
  readonly type: ExportType;
}

@Component({
  selector: 'asax-result-table-samp-container',
  templateUrl: './samp-container.component.html',
  styles:
  [
    `.dropdown-toggle::after {
      display: none;
    }`
  ]
})
export class SampContainerComponent implements OnChanges {
  @Input() selectedRowsIds: string[];
  @Input() isSampFileBeingGenerated: boolean;

  @Output() outSampExport = new EventEmitter<SampExportEvent>();

  sampSelectionType: SampSelectionType = 'all-rows';
  sampError: string;

  constructor(private readonly sampService: SampService,
              private readonly ref: ChangeDetectorRef) {
    this.sampService.getSampError().pipe(
      tap(error => this.sampError = error),
      tap(() => this.ref.markForCheck())
    ).subscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedRowsIds) {
      if (!this.selectedRowsIds?.length) {
        this.sampSelectionType = 'all-rows';
      }
    }
  }

  setSampSelectionType(sampSelectionType: SampSelectionType): void {
    if (sampSelectionType === 'selected-rows' && !this.selectedRowsIds?.length) {
      this.sampSelectionType = 'all-rows';
    } else {
      this.sampSelectionType = sampSelectionType;
    }
  }

  emitSampExport(): void {
    this.outSampExport.emit({selectionType: this.sampSelectionType, format: 'xml', type: 'application/xml'});
  }
}
